import * as React from "react";
import { IDocument } from 'src/services/interfaces/IDocument';
import DownloadDocument from 'src/components/common/GenericButtons/DownloadDocument/DownloadDocumentButton';

interface IDownloadExpenseDocumentsProps {
  documents: IDocument[];
}

export const DownloadExpenseDocuments: React.FC<IDownloadExpenseDocumentsProps> = ({ documents }) => {
  return (
    <div className="region-container documents">
      <span className="subtitle">Documentos</span>
      <div className="region-container">
        {documents.map((obj, i) =>
          <DownloadDocument key={obj.fileName + i} document={obj} />
        )}
      </div>
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/components/common/ExpenseList/Details/DownloadExpenseDocuments/DownloadExpenseDocuments.tsx